<template>
  <div id="jst_app">
    <transition name="bounce"
                mode="out-in">
      <component v-if="!answer"
              v-bind:is="currentForm"
              :formData="formData"
              @submitForm="onSubmit"
              @goBack="goBack">
      </component>
      <div v-else>
        <h3>{{answers[answer].title}}</h3>
        <p v-for="text in answers[answer].text" v-bind:key="text" v-html="text"></p>
        <p>Mikäli laitteiston ikä arveluttaa tai mietit ympäristöystävällisempää
        vaihtoehtoa, ota ihmeessä yhteyttä Jäspin asiantuntijoihin tai lähimpään
        Jäspin jälleenmyyjään. Autamme mielellämme.</p>
        <button type="button" @click="goBack(formData)">Takaisin</button>
      </div>
    </transition>
  </div>
</template>

<script>
import answers from './answers.json';

export default {
  name: 'jst_app',
  components: {
  },
  data() {
    const forms = {
      default: 'select-heating',
      oil: 'form-oil',
      electric: 'form-electric',
      wood: 'form-wood',
      geothermal: 'form-geothermal',
      district: 'form-district',
    };
    const formData = {
      heating: {
        value: 'default',
        options: [
          { text: 'Öljylämmitys', value: 'oil' },
          { text: 'Sähkölämmitys', value: 'electric' },
          { text: 'Puulämmitys', value: 'wood' },
          { text: 'Maalämpö', value: 'geothermal' },
          { text: 'Kaukolämpö', value: 'district' },
        ],
      },
    };
    return {
      forms,
      formData,
      currentForm: forms[formData.heating.value],
      answer: 0,
      previousForm: false,
      goingBack: false,
      answers,
    };
  },
  methods: {
    onSubmit(form) {
      this.goingBack = false;
      if (form.answer) {
        this.answer = form.answer;
      }
      this.formData = { ...this.formData, ...form };
      this.currentForm = this.forms[this.formData.heating.value];
    },
    goBack(form) {
      // Save form inputs
      this.formData = { ...this.formData, ...form };
      this.goingBack = true;
      // If there is an answer, we have the right form already
      // selected, so just reset that to null to go back to the form
      if (this.answer) {
        this.answer = 0;
        this.formData.answer = 0;
      } else {
        this.answer = 0;
        this.formData.answer = 0;
        this.formData.heating.value = 'default';
        this.currentForm = this.forms[this.formData.heating.value];
      }
    },
    getAnimationDirection() {
      if (this.goingBack) {
        return 'bounceback';
      }
      return 'bounce';
    },
  },
};
</script>

<style lang="scss">

#jst_app {
  font-family: 'Asap', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 60rem;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #eee;
  overflow: hidden;
  position: relative;
  font-size: 16px;
  line-height: 1.4;
  background-color: #fef1e4;
  a {
    color: blue;
  }
  a:hover,
  a:active {
    color: #983222;
  }
  .form-group {
    margin-bottom: 2rem;
  }
  h4 {
    margin-top: 2rem;
  }
  button {
    margin-top: 2rem;
    margin-right: 1rem;
    background-color: #983222;
    color: #ffffff;
    padding: 1rem;
    letter-spacing: -0.05rem;
    font-size: 14px;
    &:hover, &:active {
        color: #983222;
        background-color: #ffffff;
    }
  }
  input[type=text],
  input[type=number] {
    background-color: #fff;
  }
  input[type=radio] {
    margin-left: 1rem;
  }
  .bounce-enter-active {
    animation: bounce-in .2s ease-in;
  }
  .bounce-leave-active {
    animation: bounce-out reverse .2s ease-in;
  }
  @keyframes bounce-out {
    0% {
      transform: translateX(-100vw);
      opacity: 1;
    }
    50% {
      transform: translateX(-50vw);
      opacity: 1;
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
  @keyframes bounce-in {
    0% {
      transform: translateX(100vw);
      opacity: 1;
    }
    50% {
      transform: translateX(50vw);
      opacity: 1;
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
</style>
